import React, { useEffect, Suspense, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Outlet,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import "./App2.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./css/header.css";
import "./css/login.css";
import "./css/admin.css";
import "./css/blog.css";
import "./css/modal.css";
import "./css/addmember.css";
import "./css/antd.css";

import LoginPage from "./modules/Login/LoginPage";
import HomePage from "./modules/Customer/pages/HomePage/HomePage";
import FloatingProgressBar from "./modules/Members/components/FloatingProgressBar";

//Admin
import ForgetPassword from "./modules/ForgotPassword";
import AdminDashboard from "./modules/Dashboard/Dashboard";
import MosqueList from "./modules/Owner/pages/MosqueDetails/MosqueList";
import MosqueAdd from "./modules/Owner/pages/MosqueDetails/MosqueAdd";
// import AdminMemberList from "./modules/Owner/pages/Members/MembersListPage";
// import AdminAddMember from "./modules/Owner/pages/Members/AddMember";
import AdminSubscriptions from "./modules/Owner/pages/Subscriptions/ContactUsPage";
import AdminPlanModification from "./modules/Owner/pages/PlanModification/AdminPlanModification";

//Mosque
import Dashboard from "./modules/Dashboard/Dashboard";
import MosqueDetails from "./modules/Admin/pages/MosqueDetails/MosqueDetails";
import MembersListPage from "./modules/Members/MembersListPage";
import AddMember from "./modules/Members/AddMember";
import Subscriptions from "./modules/Admin/pages/Subscriptions/PlanModification";
import BlogList from "./modules/Admin/pages/Blogs/BlogListPage";
import BlogDetailsPage from "./modules/Admin/pages/Blogs/BlogDetailsPage";
import Finances from "./modules/Finances/Finances";
import MyPlansPage from "./modules/Admin/pages/Myplans/MyPlansPage";
import PayNowPage from "./modules/Admin/pages/PayNow/PayNowPage";
import AdminsPage from "./modules/Admin/pages/Admins/AdminsPage";
import NavbarSidebar from "./modules/components/NavbarSidebar/NavbarSidebar";

import CustomForm from "./components/Form/CustomForm";
import SuccessPage from "./components/SuccessPage";
import DonateListPage from "./modules/Admin/pages/Donate/DonateListPage";
import DonationForm from "./modules/Admin/pages/Donate/DonationForm";
import DonationSuccess from "./modules/Admin/pages/Donate/DonationSuccess";
import MosqueView from "./modules/Admin/pages/MosqueView/MosqueView";
import MosqueViewerAccess from "./modules/Admin/pages/MosqueView/MosqueViewerAccess";

import { ToastContainer } from "react-toastify";
import {
  fetchUserProfile,
  getUserRoleConfig,
  setAuthentication,
  setAuthState,
  setUserId,
  setUserType,
} from "./modules/appAction";

import {
  AUTHENTICATED,
  AUTHENTICATING,
  NOT_AUTHENTICATED,
} from "./constants/authEnums";
import FullPageLoader from "./components/FullPageLoader/FullPageLoader";
import { APP_TOKEN, USER_ID, USER_TYPE } from "./constants/appEnums";
import RedirectPage from "./modules/Owner/pages/RedirectPage/RedirectPage";
import Fund from "./modules/Admin/pages/Fund/Fund";
import { fetchSaasPlanList } from "./modules/Owner/ownerAction";
import { fetchCountries } from "./modules/Admin/adminAction";
import IdleTimer from "./components/IdleTimer";
import EditForm from "./modules/Members/components/EditForm";
import ResetPassword from "./modules/Reset/ResetPassword";

import i18next from "./services/i18next";
import BulkUploadMembers from "./modules/Members/BulkUploadMembers";
import UserProfile from "./modules/UserProfile/Profile";
import { handleLogOut } from "./util/Utility";

function App() {
  const dispatch = useDispatch();

  const token = localStorage.getItem(APP_TOKEN);
  const userType = localStorage.getItem(USER_TYPE);
  const userId = localStorage.getItem(USER_ID);
  const [mosque, setMosque] = useState(null);
  const authState = useSelector((state) => state?.appReducer?.authState);
  const isAuthenticated = useSelector((state) => state?.appReducer?.isAuthenticated);


  useEffect(() => {
    const timer = new IdleTimer({
      timeout: 6000,
      onTimeout: () => {
        handleLogOut();
      },
      onExpired: () => {
        handleLogOut();
      },
    });

    const getLanguage = () => {
      if (localStorage.getItem("language")) {
        i18next.changeLanguage(localStorage.getItem("language"));
      } else {
        localStorage.setItem("language", "nl");
        i18next.changeLanguage("nl");
      }
      // i18next.changeLanguage(localStorage.getItem('language')?localStorage.getItem('language'):'nl')
    };
    getLanguage();
    return () => {
      timer.cleanUp();
    };
  }, []);

  useEffect(() => {
    try {
      dispatch(setAuthState(AUTHENTICATING));
      if (token) {
        dispatch(getUserRoleConfig(userId, userType));
        dispatch(setAuthState(AUTHENTICATED));
        dispatch(setAuthentication(true));
        dispatch(setUserId(userId));
        dispatch(setUserType(userType));
        dispatch(fetchUserProfile(userId, userType));
      } else {
        dispatch(setAuthState(NOT_AUTHENTICATED));
        dispatch(setAuthentication(false));
      }
    } catch (err) {
      dispatch(setAuthState(NOT_AUTHENTICATED));
      dispatch(setAuthentication(false));
    }
  }, []);

  useEffect(() => {
    dispatch(fetchCountries());
    dispatch(fetchSaasPlanList());
  }, [dispatch]);

  const AuthenticatedRoutes = () => {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path={"/login"} element={<LoginPage />} />
          <Route path={"/login"} element={<RedirectPage />} />
          <Route path={"reset-password"} element={<ResetPassword />}></Route>
          <Route path={"forgot-password"} element={<ForgetPassword />}></Route>
          <Route
            path={"/user/"}
            element={
              <NavbarSidebar>
                <Outlet />
              </NavbarSidebar>
            }
          >
            <Route path={"dashboard"} element={<Dashboard />}></Route>
            <Route path={"details"} element={<MosqueDetails />}></Route>
            <Route path={"members"} element={<MembersListPage />}></Route>
            <Route path={"add-members"} element={<AddMember />}></Route>
            <Route path={"mosque/add"} element={<MosqueAdd />}></Route>
            <Route
              path={"add-members/bulk-upload"}
              element={<BulkUploadMembers />}
            ></Route>
            <Route
              path={"members/:memberId/edit"}
              element={<EditForm />}
            ></Route>
            <Route path={":id/fund"} element={<Fund />}></Route>
            <Route path={"subscriptions"} element={<Subscriptions />}></Route>
            <Route path={"news"} element={<BlogList />}></Route>
            <Route path={"finances"} element={<Finances />}></Route>
            <Route path={"mosques"} element={<MosqueList />}></Route>
            <Route path={"profile"} element={<UserProfile />}></Route>
            <Route path={"donate"} element={<DonateListPage />}></Route>
            <Route path={"mosque_view"} element={<MosqueView />}></Route>
            <Route path={"viewer_access"} element={<MosqueViewerAccess />}></Route>
            <Route
              path={"news/:blog_id/edit"}
              element={<BlogList />}
            ></Route>
            <Route
              path={"news/:id/:url/info"}
              element={<BlogDetailsPage editMode={"false"} />}
            ></Route>
            <Route
              path={":id/blogs/:url/edit"}
              element={<BlogDetailsPage editMode={"true"} />}
            ></Route>
            <Route path={":id/my-plans"} element={<MyPlansPage />}></Route>
            <Route path={":id/pay-now"} element={<PayNowPage />}></Route>
            <Route path={":id/admins"} element={<AdminsPage />}></Route>
          
          </Route>
          {/* Admin */}
          <Route
            path={"/admin"}
          >
            <Route path={"login"} element={<RedirectPage />} />
            <Route path={"dashboard"} element={<AdminDashboard />}></Route>
            {/* <Route path={"members"} element={<AdminMemberList />}></Route> */}
            {/* <Route path={"members/info"} element={<AdminAddMember />}></Route> */}
            <Route
              path={"planModification"}
              element={<AdminPlanModification />}
            ></Route>
            <Route
              path={"subscriptions"}
              element={<AdminSubscriptions />}
            ></Route>
          </Route>

  
          <Route
            path="/mosque/:mosqueId/member/register"
            element={<CustomForm />}
          />
          <Route
            path="/mosque/:mosqueId/member/register/success"
            element={<SuccessPage mosque={mosque} />}
          />
          <Route path="/donation-form" element={<DonationForm />} />
          <Route path="/donation-form/success" element={<DonationSuccess />} />
        </Routes>
      </Router>
    );
  };

  const NotAuthenticatedRoutes = () => {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path={"/login"} element={<RedirectPage />} />
          <Route path={"/reset-password"} element={<ResetPassword />} />
          <Route path={"/forgot-password"} element={<ForgetPassword />}></Route>
          <Route
            path="/mosque/:mosqueId/member/register"
            element={<CustomForm />}
          />
          <Route
            path="/mosque/:mosqueId/member/register/success"
            element={<SuccessPage mosque={mosque} />}
          />
          <Route path="/donation-form" element={<DonationForm />} />
          <Route path="/donation-form/success" element={<DonationSuccess />} />
          <Route
            path={"/mosque/:id/:id"}
            element={<RedirectPage isMosque />}
          ></Route>
          <Route
            path={"/customer/:id/:id"}
            element={<RedirectPage isCustomer />}
          ></Route>
          <Route path={"/admin/:id"} element={<RedirectPage isAdmin />}></Route>
        </Routes>
      </Router>
    );
  };

  const getRoutes = () => {
    switch (authState) {
      case AUTHENTICATED:
        return <AuthenticatedRoutes />;
      case NOT_AUTHENTICATED:
        return <NotAuthenticatedRoutes />;
      case AUTHENTICATING:
        return <FullPageLoader />;
      default:
        return <FullPageLoader />;
    }
  };

  return (
    <React.Fragment>
      <div className="App">
        <ThemeProvider theme={theme}>
          <Suspense fallback={<FullPageLoader />}>{getRoutes()}</Suspense>
          <FloatingProgressBar />
        </ThemeProvider>
        <ToastContainer />
      </div>
    </React.Fragment>
  );
}

export default App;
